(function () {
  var SECTION_SELECTOR = '.oddit-section-newsletter-popup';

  function initSection(section) {
    if (!section || section.dataset.odditInit === 'true') return;
    section.dataset.odditInit = 'true';

    var overlay = section.querySelector('[data-popup-overlay]');

    function closePopup() {
      section.classList.add('is-hidden');
      document.documentElement.style.overflow = '';
    }

    section.addEventListener('click', function (event) {
      var closeTrigger = event.target.closest('[data-popup-close]');
      if (closeTrigger) {
        event.preventDefault();
        closePopup();
        return;
      }

      if (event.target === overlay) {
        closePopup();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !section.classList.contains('is-hidden')) {
        closePopup();
      }
    });
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();